export default "__VITE_ASSET__DzxmRimz__"